const Disconnect = () => {
  return (
    <svg
      width='95'
      height='95'
      viewBox='0 0 95 95'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2415_235877)'>
        <path
          d='M66.1089 56.2625C63.5227 66.517 85.4258 64.7099 80.1725 72.3181C74.9192 79.9262 67.0433 76.3201 48.2017 74.3924C29.36 72.4647 14.1586 88.3504 16.7073 74.3924C19.2561 60.4344 27.9019 61.9031 21.1145 53.5122C14.3271 45.1213 9.85637 14.8838 21.1145 14.8838C30.1941 14.8838 46.3705 37.6119 67.1268 33.8617C87.8831 30.1116 68.6951 46.0081 66.1089 56.2625Z'
          fill='#E7F1FD'
        />
        <path
          d='M14.882 22.1711C19.4843 21.6188 20.2367 27.65 22.4943 29.3606C23.1479 29.6113 24.6818 30.9293 22.5557 31.2729C20.4296 31.6165 18.4737 23.491 13.9299 24.2254C9.38607 24.9597 6.41434 16.1103 7.69903 14.063C8.47718 12.823 11.0658 11.9474 9.89347 14.2155C8.17758 17.5352 12.0478 22.5112 14.882 22.1711Z'
          fill='#78A7FF'
        />
        <rect
          x='20.9282'
          y='31.2051'
          width='2.68021'
          height='4.35535'
          rx='1.02103'
          transform='rotate(-61.04 20.9282 31.2051)'
          fill='#2538BF'
        />
        <rect
          x='21.9126'
          y='36.3447'
          width='10.7209'
          height='8.04064'
          rx='1.02103'
          transform='rotate(-61.04 21.9126 36.3447)'
          fill='#4B8AFF'
        />
        <rect
          x='26.2451'
          y='40.6567'
          width='14.0711'
          height='13.4455'
          rx='1.34011'
          transform='rotate(-61.04 26.2451 40.6567)'
          fill='#78A7FF'
        />
        <path
          d='M41.3715 40.1011L41.2445 39.3927C41.2295 39.3092 41.1203 39.2851 41.071 39.3541C40.6067 40.0047 39.0012 42.1925 37.4828 43.5332C36.1513 44.7089 35.6482 45.0829 34.6597 45.0759C34.5572 45.0752 34.5139 45.2196 34.6032 45.2698L37.0787 46.6621L41.3715 40.1011Z'
          fill='#2538BF'
        />
        <rect
          width='17.0864'
          height='2.68021'
          rx='1.02103'
          transform='matrix(0.48481 -0.87462 -0.87462 -0.48481 38.7178 49.2222)'
          fill='#4B8AFF'
        />
        <path
          d='M75.684 72.6798C67.1415 73.1722 65.4823 68.8566 64.155 66.8657C63.681 66.7708 62.771 67.3326 62.8847 67.5601C63.027 67.8446 67.0658 75.8938 74.1196 75.0974C81.1734 74.301 78.9549 77.9417 80.9459 80.5016C82.9369 83.0614 85.9234 79.5061 83.2213 80.0749C80.5192 80.6438 84.2265 72.1874 75.684 72.6798Z'
          fill='#78A7FF'
        />
        <rect
          width='2.01016'
          height='8.04064'
          rx='1.00508'
          transform='matrix(0.75654 -0.653947 -0.653947 -0.75654 51.1016 59.6411)'
          fill='white'
        />
        <rect
          width='2.68021'
          height='4.35535'
          rx='1.02103'
          transform='matrix(0.75654 -0.653947 -0.653947 -0.75654 63.0225 68.8213)'
          fill='#2538BF'
        />
        <rect
          width='2.01016'
          height='8.04064'
          rx='1.00508'
          transform='matrix(0.75654 -0.653947 -0.653947 -0.75654 56.1709 55.2593)'
          fill='white'
        />
        <rect
          width='14.0711'
          height='10.3858'
          rx='1.34011'
          transform='matrix(0.75654 -0.653947 -0.653947 -0.75654 53.6748 66.7163)'
          fill='#78A7FF'
        />
        <rect
          width='11.7259'
          height='5.69545'
          rx='1.34011'
          transform='matrix(0.75654 -0.653947 -0.653947 -0.75654 57.2832 69.354)'
          fill='#78A7FF'
        />
        <path
          d='M56.9309 62.9809L56.8121 63.6908C56.7981 63.7744 56.8929 63.8339 56.9625 63.7855C57.6187 63.3292 59.8668 61.8093 61.7479 61.0578C63.3973 60.3988 63.997 60.2159 64.9255 60.5552C65.0217 60.5904 65.1111 60.469 65.0439 60.3916L63.1814 58.2474L56.9309 62.9809Z'
          fill='#2538BF'
        />
        <rect
          width='17.0864'
          height='2.68021'
          rx='1.02103'
          transform='matrix(0.75654 -0.653947 -0.653947 -0.75654 52.4077 67.812)'
          fill='#4B8AFF'
        />
        <path
          d='M53.6942 26.8185C53.8063 26.1986 54.4361 25.817 55.0375 26.0046L55.8703 26.2644L56.703 26.5242C57.3044 26.7118 57.6055 27.3839 57.3453 27.9576L54.0951 35.1214C53.897 35.5582 53.4044 35.7788 52.9466 35.636V35.636C52.4887 35.4932 52.209 35.0316 52.2944 34.5596L53.6942 26.8185Z'
          fill='#2974FF'
        />
        <path
          d='M69.5829 36.2547C70.154 36.0038 70.8165 36.3043 71.004 36.8993L71.5567 38.6542L72.1095 40.409C72.297 41.004 71.9263 41.63 71.3145 41.7517L57.2926 44.5412C56.7682 44.6455 56.2493 44.3383 56.0886 43.8282L55.9158 43.2796C55.7552 42.7696 56.0043 42.2204 56.4938 42.0053L69.5829 36.2547Z'
          fill='#2974FF'
        />
        <path
          d='M33.5879 65.1022C33.2342 65.6033 33.3845 66.2997 33.9134 66.6103L34.7057 67.0755L35.498 67.5407C36.0269 67.8513 36.7083 67.6432 36.9735 67.0902L42.415 55.7436C42.6202 55.3155 42.4633 54.8016 42.054 54.5612V54.5612C41.6446 54.3208 41.1193 54.4342 40.8455 54.822L33.5879 65.1022Z'
          fill='#2974FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_2415_235877'>
          <rect
            width='95.0039'
            height='95.0039'
            fill='white'
            transform='translate(-0.00390625)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Disconnect
